import React from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CBadge,
    CButton,
} from '@coreui/react-pro';

export const MarketingCoupons: React.FC = () => {
    const coupons = [
        { id: 1, code: 'BIENVENIDA20', type: 'Porcentaje', value: '20%', limit: '100/500', expires: '2026-12-31', status: 'active' },
        { id: 2, code: 'FREESHIP', type: 'Envío Gratis', value: '$0 Delivery', limit: '50/50', expires: '2026-09-01', status: 'expired' },
    ];

    return (
        <CCard className="shadow-sm border-0 mb-4">
            <CCardHeader className="bg-white fw-bold d-flex justify-content-between align-items-center py-3">
                <span>Cupones de Descuento</span>
                <CButton size="sm" className="text-white fw-bold" style={{ backgroundColor: '#FE2445', borderColor: '#FE2445' }}>
                    + Crear Cupón
                </CButton>
            </CCardHeader>
            <CCardBody className="p-0">
                <CTable align="middle" responsive hover className="mb-0">
                    <CTableHead color="light">
                        <CTableRow>
                            <CTableHeaderCell>Código</CTableHeaderCell>
                            <CTableHeaderCell>Tipo</CTableHeaderCell>
                            <CTableHeaderCell>Valor</CTableHeaderCell>
                            <CTableHeaderCell>Usos (Usados/Límite)</CTableHeaderCell>
                            <CTableHeaderCell>Vencimiento</CTableHeaderCell>
                            <CTableHeaderCell>Estado</CTableHeaderCell>
                            <CTableHeaderCell className="text-end">Acciones</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {coupons.map((c) => (
                            <CTableRow key={c.id}>
                                <CTableDataCell><CBadge color="dark" className="fs-6">{c.code}</CBadge></CTableDataCell>
                                <CTableDataCell>{c.type}</CTableDataCell>
                                <CTableDataCell className="fw-bold">{c.value}</CTableDataCell>
                                <CTableDataCell>{c.limit}</CTableDataCell>
                                <CTableDataCell>{c.expires}</CTableDataCell>
                                <CTableDataCell>
                                    <CBadge color={c.status === 'active' ? 'success' : 'danger'}>
                                        {c.status === 'active' ? 'Activo' : 'Expirado'}
                                    </CBadge>
                                </CTableDataCell>
                                <CTableDataCell className="text-end">
                                    <CButton color="light" size="sm">Editar</CButton>
                                </CTableDataCell>
                            </CTableRow>
                        ))}
                    </CTableBody>
                </CTable>
            </CCardBody>
        </CCard>
    );
};

export default MarketingCoupons;